export default __webpack_public_path__ + "static/media/nora_garden.c6575766.jpg";